(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _newArrowCheck(innerThis, boundThis) { if (innerThis !== boundThis) { throw new TypeError("Cannot instantiate an arrow function"); } }

/* eslint-disable no-plusplus */
var mobileCaseStudy = function mobileCaseStudy() {
  var _this = this;

  var w = window;
  var d = document;
  var e = d.documentElement;
  var g = d.getElementsByTagName("body")[0];
  var windowWidth = w.innerWidth || e.clientWidth || g.clientWidth;
  var f;

  if (windowWidth <= 767) {
    // Highlights items that are in center of viewport (portfolio items on mobile)
    var getElementsInArea = function (docElm) {
      var _this2 = this;

      _newArrowCheck(this, _this);

      var viewportHeight = docElm.clientHeight;
      return function (e, opts) {
        _newArrowCheck(this, _this2);

        var found = [];
        var i;

        if (e && e.type === "resize") {
          viewportHeight = docElm.clientHeight;
        }

        for (i = opts.elements.length; i--;) {
          var elm = opts.elements[i];
          var pos = elm.getBoundingClientRect();
          var topPerc = pos.top / viewportHeight * 100;
          var bottomPerc = pos.bottom / viewportHeight * 100;
          var middle = (topPerc + bottomPerc) / 2;
          var inViewport = middle > opts.zone[1] && middle < 100 - opts.zone[1];
          elm.classList.toggle(opts.markedClass, inViewport);

          if (inViewport) {
            found.push(elm);
          }
        }
      }.bind(this);
    }.bind(this)(document.documentElement);

    f = function f(e) {
      _newArrowCheck(this, _this);

      getElementsInArea(e, {
        elements: document.querySelectorAll(".item"),
        markedClass: "highlight--1",
        zone: [30, 20] // percentage distance from top & bottom

      });
    }.bind(this);
  }

  window.addEventListener("scroll", f, {
    passive: true
  });
  window.addEventListener("resize", f);
}; // mobileCaseStudy


var _default = mobileCaseStudy;
exports.default = _default;

},{}],2:[function(require,module,exports){
"use strict";

var _mobileCaseStudy = _interopRequireDefault(require("./inc/_mobile-case-study"));

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _newArrowCheck(innerThis, boundThis) { if (innerThis !== boundThis) { throw new TypeError("Cannot instantiate an arrow function"); } }

document.addEventListener("DOMContentLoaded", function () {
  _newArrowCheck(this, _this);

  if (document.querySelector(".home-portfolio")) (0, _mobileCaseStudy.default)();
}.bind(void 0));

},{"./inc/_mobile-case-study":1}]},{},[2]);
